<template>
  <section class="section signin">

    <h1 class="title has-text-centered" id="signin-title">Bli medlem</h1>

<div class="container">


    <div class="container has-text-centered" id="something">Velg by</div>
    <div class="tabs is-toggle is-centered" id="cityTabs">
      <ul>
        <li :class="{'is-active' : isActiveCity('Trondheim')}" @click="setActiveCity('Trondheim')">
          <a>
            <span>Trondheim</span>
          </a>
        </li>
        <li :class="{'is-active' : isActiveCity('Oslo')}" @click="setActiveCity('Oslo')">
          <a>
            <span>Oslo</span>
          </a>
        </li>
        <li :class="{'is-active' : isActiveCity('Bergen')}" @click="setActiveCity('Bergen')">
          <a>
            <span>Bergen</span>
          </a>
        </li>
        <li :class="{'is-active' : isActiveCity('Stavanger')}" @click="setActiveCity('Stavanger')">
          <a>
            <span>Stavanger</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="modal is-active" v-if="isActiveCity('Oslo') || isActiveCity('Bergen') || isActiveCity('Stavanger')">
      <div class="modal-background" @click="activeCity = 'Trondheim'"></div>
      <div class="modal-card">
        <button class="delete" @click="activeCity = 'Trondheim'" aria-label="close"></button>
        <section class="modal-card-body">

          <div v-if="isActiveCity('Oslo')">

            <!--Oslo-->
            <h1 class="title is-3">Så gøy at du er interessert i Combine!</h1>
            <p>Combine kommer til {{activeCity}} 1. juni! Registrer eposten din, så tar vi kontakt når det nærmer seg!</p> <br>

            <div class="field has-addons is-centered">
              <div class="control">
                <input class="input" type="email" placeholder="Epost" v-model="subscriberEmail">
              </div>
              <div class="control">
                <a class="button is-info" @click="submitNewEmailOslo()">
                  Registrer
                </a>
              </div>
            </div>

            <div class="notification is-success" v-if="signedUpMailingListSuccess">
              <button class="delete"></button>
              Du er nå påmeldt mailinglisten for pilotprosjektet i {{activeCity}}! Vi tar kontakt når det nærmer seg :)
            </div>

          </div>


          <div v-if="isActiveCity('Bergen')">

            <!--Oslo-->
            <h1 class="title is-3">Så gøy at du er interessert i Combine!</h1>
            <p>Combine kommer til {{activeCity}} snart! Registrer eposten din, så tar vi kontakt når det nærmer seg!</p> <br>

            <div class="field has-addons is-centered">
              <div class="control">
                <input class="input" type="email" placeholder="Epost" v-model="subscriberEmail">
              </div>
              <div class="control">
                <a class="button is-info" @click="submitNewEmailBergen()">
                  Registrer
                </a>
              </div>
            </div>

            <div class="notification is-success" v-if="signedUpMailingListSuccess">
              <button class="delete"></button>
              Du er nå påmeldt mailinglisten for Combine i {{activeCity}}! Vi tar kontakt når det nærmer seg lansering :)
            </div>

          </div>

          <div v-if="isActiveCity('Stavanger')">

            <!--Oslo-->
            <h1 class="title is-3">Så gøy at du er interessert i Combine!</h1>
            <p>Combine kommer til {{activeCity}} snart! Registrer eposten din, så tar vi kontakt når det nærmer seg!</p> <br>

            <div class="field has-addons is-centered">
              <div class="control">
                <input class="input" type="email" placeholder="Epost" v-model="subscriberEmail">
              </div>
              <div class="control">
                <a class="button is-info" @click="submitNewEmailStavanger()">
                  Registrer
                </a>
              </div>
            </div>

            <div class="notification is-success" v-if="signedUpMailingListSuccess">
              <button class="delete"></button>
              Du er nå påmeldt e-postliste for Combine i {{activeCity}}! Vi tar kontakt når det nærmer seg lansering :)
            </div>

          </div>

        </section>
      </div>
    </div>

    <div class="column">

      <div class="card" id="login-card">
        <div class="card-whole">

          <div class="card-content">

            <!--    <button class="button" id="btn-login-fb" @click="signUpWithFacebook()">Logg inn med Facebook</button>

            <button class="button" id="btn-login-google" @click="signUpWithGoogle()">Logg inn med Google</button>


            <div class="columns">
            <div class="column">
            <hr>
          </div>
          <label class="label" id="divider-label">eller</label>
          <div class="column">
          <hr>
        </div>

      </div> -->

      <form v-on:submit.prevent>
        <div class="field">
          <label class="label">Navn</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="firstName">
          </div>
        </div>
        <div class="field">
          <label class="label">Etternavn</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="lastName">
          </div>
        </div>

        <div class="field">
          <label class="label">Epost</label>
          <p class="control">
            <input class="input" type="email" placeholder="" v-model="email">
          </p>
        </div>

        <div class="field">
          <label class="label">Telefonnummer</label>
          <p class="control">
            <input class="input" type="number" placeholder="" v-model="tnr">
          </p>
        </div>

        <div class="field">
          <label class="label">Passord</label>
          <div class="control">
            <input class="input" type="password" placeholder="" v-model="password">
          </div>
        </div>
        <div class="field">
          <label class="label">Bekreft Passord</label>
          <div class="control">
            <input class="input" type="password" placeholder="" v-model="passwordConfirm">
          </div>
        </div>

        <button type="submit" class="button is-primary" v-on:click="signUp" id="btn-login">Bli medlem</button>
        <br><br><a href="/sign-in" id="forgot-pass">Allerede medlem? Logg inn her</a>
      </form>
    </div>
  </div>
</div>
</div>

</div>



</section>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      tnr: "",
      password: "",
      passwordConfirm: "",

      activeCity: 'Trondheim',
      signedUpMailingListSuccess: false,
      subscriberEmail: '',
    };
  },
  methods: {
    submitNewEmailOslo: function() {

      var mailListKey = Firebase.database().ref().child('mailinglist/oslo').push().key;

      var updates = {};
      updates['mailinglist/oslo/' + mailListKey] = this.subscriberEmail;
      this.signedUpMailingListSuccess = true;
      return Firebase.database().ref().update(updates);
    },
    submitNewEmailBergen: function() {

      var mailListKey = Firebase.database().ref().child('mailinglist/bergen').push().key;

      var updates = {};
      updates['mailinglist/bergen/' + mailListKey] = this.subscriberEmail;
      this.signedUpMailingListSuccess = true;
      return Firebase.database().ref().update(updates);
    },
    submitNewEmailStavanger: function() {

      var mailListKey = Firebase.database().ref().child('mailinglist/stavanger').push().key;

      var updates = {};
      updates['mailinglist/stavanger/' + mailListKey] = this.subscriberEmail;
      this.signedUpMailingListSuccess = true;
      return Firebase.database().ref().update(updates);
    },
    isActiveCity: function(city){
      return this.activeCity === city;
    },
    setActiveCity: function(city) {
      this.activeCity = city;
    },
    signUpWithGoogle: function() {
      var signUpGoogleProvider = new Firebase.auth.GoogleAuthProvider();

      signUpGoogleProvider.addScope('profile');
      signUpGoogleProvider.addScope('email');

      Firebase.auth().signInWithPopup(signUpGoogleProvider).then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;

        var userID = user.uid;

        var fn = user.displayName;

        Firebase.database().ref('users/' + userID).set({
          firstName: fn,
          lastName: ln,
          email: em,
          tnr: tnr,
        });

        this.$router.replace('user');
        // ...
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
      this.$router.replace('user');

    },
    signUpWithFacebook: function(){

      var signUpFacebookProvider = new Firebase.auth.FacebookAuthProvider();

      signUpFacebookProvider.addScope('public_profile');

      Firebase.auth().signInWithPopup(signUpFacebookProvider).then(function(result) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        console.log(user);


        $http.get('https://graph.facebook.com/v2.5/me?  access_token='+token+'&fields=id,name,first_name,last_name,email')
        .success(function(jsonService){
          var a= jsonService.first_name;
          $scope.user.lastName= jsonService.last_name
          $scope.user.email = jsonService.email;
          console.log(a);
          console.log('hello');
        });

        /*  Firebase.database().ref('users/' + userID).set({
        firstName: fn,
      }); */

      // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });

    Firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var token = result.credential.accessToken;
        console.log(token);
        // ...
      }
      // The signed-in user info.
      var user = result.user;
      console.log(user);


    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });

    //  this.$router.replace('user');
  },
  signUp: function() {
    if(this.password != this.passwordConfirm){return alert('Passordene stemmer ikke overens')};

    Firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
      user => {

        var userID = user.uid;

        return Firebase.database().ref('users/' + userID).set({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          tnr: this.tnr,
        })
      },
      error => {
        alert(error.message);
      }

    ).then(user =>{
      window.location.replace('https://combine.no'+'/order/');
    });
  },
}

};
</script>

<style lang="scss">

@media screen and (max-width: 768px) {

  .section.signin{
    padding-top: 80px;
    background-color: #F5F7F9;
  }

  #btn-login{
    background-color: #33335D;
    width: 255px;
  }

}


@media screen and (min-width: 768px) {

  .section.signin{
    padding-top: 110px;
    background-color: #F5F7F9;
  }

  div.card#login-card {
    margin-left: auto;
    margin-right: auto;
    max-width: 350px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.0);
    transition: all 0.5s
  }

  #cityTabs{
    font-size: 16px;
  }

  #btn-login{
    background-color: #33335D;
    width: 300px;
  }

  #signin-title {
    font-family: 'Monserrat', sans-serif;
    font-weight: 400;
    font-size: 24px;
    font-weight: 800;
  }

  .label {
    font-size: 14px;
    font-family: 'Monserrat', sans-serif;
  }

  #btn-login{
    font-family: 'Monserrat', sans-serif;
    font-weight: 600;
  }

  #divider-label {
    margin-top: 25px;
  }

  #btn-login-fb {
    width: 300px;
    border-radius: 0px;
    background-color: #385794;
    color: white;
  }
  #btn-login-google {
    width: 300px;
    border-radius: 0px;
    background-color: white;
    color: black;
  }
  #forgot-pass{
    font-size: 14px;
    color: #3a3a3a;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue